module.exports = __webpack_public_path__ + "static/media/TRIAL 3.1e20ff7e.mp3";